import { NgModule } from '@angular/core';
import { EntityDataService, EntityServices } from '@ngrx/data';
import { MedicalToolSetRepository } from './impl/service/repository/medicalToolSet.repository';
import { MedicalToolSetDataService } from './impl/service/repository/medicalToolSet.dataservice';
import {errorMessages} from "../../../core/error/errorMessages";

@NgModule({
})
export class MedicalToolSetModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: MedicalToolSetRepository,
                dataService: MedicalToolSetDataService) {
        entityDataService.registerServices({
            MedicalToolSet: dataService,
        });

        entityServices.registerEntityCollectionServices({
            MedicalToolSet: repository,
        });

        errorMessages.set('MEDICAL_INSTRUMENT_SET_ALREADY_USED', 'Le set d\'instrument a déjà été utilisé.');
    }
}

